var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.width,
        viewBox: "0 0 26 26",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            fill: "none",
            "fill-rule": "evenodd",
            transform: "translate(1 1)",
          },
        },
        [
          _c("circle", {
            attrs: {
              cx: "12",
              cy: "12",
              r: "12",
              fill: "#FFD879",
              stroke: "#E2C172",
            },
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "7.647", cy: "8.877", r: "2.108", fill: "#3C5396" },
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "16.079", cy: "8.877", r: "2.108", fill: "#3C5396" },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              stroke: "#3C5396",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.5",
              d: "M7.385 14.77s1.454 2.46 4.923 2.46c3.468 0 4.923-2.46 4.923-2.46",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }